import { useVariant } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState } from 'react';
import bannerImage from './images/banner_image_payments.png';
import { useGetUserQuery, useUpdateUserGrowthExperimentsMutation } from '../../../common';
import { TRACKING_EVENT_NAMES, useTrack, useTrackOnce } from '../../../hooks/analytics_events';
import { hasOnboardingPaymentsFlag, isOnboardingPaymentsBannerVariant, ONBOARDING_PAYMENTS_EXPERIMENT_KEY } from '../../../hooks/growth_experiments/use-onboarding-payments-experiment';
const bannerCss = "b1w175xn";
const contentWithIllustrationCss = "cdy7x62";
const contentWithoutIllustrationCss = "c11jpfbv";
const contentCss = "c1jok0q2";
const illustrationSpacerCss = "ilmfvo0";
const illustrationCss = "i1o6rez4";
const textStackWithoutIllustrationCss = "tabaf9n";
const textStackCss = "t1h6mekt";
const titleCss = "t12occ6e";
const descriptionCss = "d1b530h6";
const learnMoreLinkCss = "lbs61f0";
const closeIconCss = "cuftszy";
const closeButtonCss = "cai3jsw";
const BANNER_DISMISSED_KEY = 'event_type_banner_dismissed';
const StyledCloseIcon = props => <CloseIcon {...props} className={classNames(closeIconCss, props.className)} />;
const OnboardingPaymentsBannerBody = ({
  onClose,
  onLearnMore
}) => {
  const isPhone = useDeviceType('isPhone');
  const showIllustration = !isPhone;
  return <div className={bannerCss}>
      <BareButton aria-label={I18n.t('publisher.action.close')} className={closeButtonCss} onClick={onClose}>
        <StyledCloseIcon />
      </BareButton>
      <div className={classNames(contentCss, {
      [contentWithIllustrationCss]: showIllustration,
      [contentWithoutIllustrationCss]: !showIllustration
    })}>
        {showIllustration && <div className={illustrationSpacerCss} aria-hidden="true">
            <img src={bannerImage} alt="" className={illustrationCss} />
          </div>}
        <div className={classNames(textStackCss, {
        [textStackWithoutIllustrationCss]: !showIllustration
      })}>
          <TitleText level="4" className={titleCss}>
            {I18n.t('publisher.growth_experiments.onboarding_payments.banner_title')}
          </TitleText>
          <BodyText size="medium" className={descriptionCss}>
            {I18n.t('publisher.growth_experiments.onboarding_payments.banner_description')}
            {' '}
            <Link href="/integrations?category=payments" className={learnMoreLinkCss} onClick={onLearnMore}>
              {I18n.t('publisher.growth_experiments.onboarding_payments.banner_learn_more')}
            </Link>
          </BodyText>
        </div>
      </div>
    </div>;
};
const ExperimentOnboardingPaymentsBannerContent = () => {
  const variant = useVariant(ONBOARDING_PAYMENTS_EXPERIMENT_KEY);
  const shouldShow = isOnboardingPaymentsBannerVariant(variant);
  const {
    data: userData
  } = useGetUserQuery();
  const [updateGrowthExperiments] = useUpdateUserGrowthExperimentsMutation();
  const track = useTrack();
  const [isDismissed, setIsDismissed] = useState(false);
  const existingExperimentState = userData?.growth_experiments?.[ONBOARDING_PAYMENTS_EXPERIMENT_KEY] || {};
  const isBannerDismissed = Boolean(existingExperimentState[BANNER_DISMISSED_KEY]);
  const hasUser = Boolean(userData?.uuid || userData?.id);
  const dismissalPayload = {
    [ONBOARDING_PAYMENTS_EXPERIMENT_KEY]: {
      ...existingExperimentState,
      [BANNER_DISMISSED_KEY]: true
    }
  };
  useTrackOnce(hasUser && shouldShow && !isDismissed && !isBannerDismissed, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    properties: {
      cta_key: 'scheduling_page',
      cta_text: 'get_paid_before_client_meetings'
    }
  });
  const handleClose = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'dismissed',
        cta_key: 'scheduling_page',
        cta_text: 'get_paid_before_client_meetings'
      }
    });
    setIsDismissed(true);
    updateGrowthExperiments(dismissalPayload);
  };

  // Don't show until user data is loaded to prevent mutation failures
  if (!hasUser || !shouldShow || isDismissed || isBannerDismissed) {
    return null;
  }
  return <OnboardingPaymentsBannerBody onClose={handleClose} onLearnMore={() => track({
    name: TRACKING_EVENT_NAMES.CTA_CLICKED,
    properties: {
      action: 'interaction',
      cta_key: 'scheduling_page',
      cta_text: 'get_paid_before_client_meetings'
    }
  })} />;
};
export const OnboardingPaymentsBanner = () => {
  if (!hasOnboardingPaymentsFlag()) {
    return null;
  }
  return <ExperimentOnboardingPaymentsBannerContent />;
};

require("./onboarding_payments_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./onboarding_payments_banner.js");